export default __webpack_public_path__ + "static/media/glasses.4fb801bf.svg";